
define('ldsh!modules/estimate_line/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>EstimateLine</h1>\n<a class="btn btn-default" href="#/estimate_line/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   name\n  </th>\n  \n  <th>\n   description\n  </th>\n  \n  <th>\n   unitCost\n  </th>\n  \n  <th>\n   quantity\n  </th>\n  \n  <th>\n   tax1Name\n  </th>\n  \n  <th>\n   tax2Name\n  </th>\n  \n  <th>\n   tax2Percent\n  </th>\n  \n  <th>\n   tax1Percent\n  </th>\n  \n  <th>\n   type\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="EstimateLine-body">\n\t</tbody>\n</table>';

}
return __p
};});

